var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"iconmonstr-x-mark-2","d":"M27.954,24.543,17.239,13.932l10.607-10.7-3.3-3.275L13.938,10.663,3.232.06-.046,3.339,10.671,13.961.06,24.676l3.278,3.278L13.969,17.23l10.71,10.617Z","transform":"translate(0.046 0.046)","fill":"#8d8d8d"}));
}

Cross.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = Cross;

Cross.default = Cross;
